import { render, staticRenderFns } from "./JSONViewer.vue?vue&type=template&id=0420c5b8&scoped=true"
import script from "./JSONViewer.vue?vue&type=script&lang=js"
export * from "./JSONViewer.vue?vue&type=script&lang=js"
import style0 from "./JSONViewer.vue?vue&type=style&index=0&id=0420c5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0420c5b8",
  null
  
)

export default component.exports